<template>
  <div class="container">
    <a-modal
      class="gufiiguy"
      title="新增检测类别"
      :visible="addCategoryVisible"
      @cancel="closeAddCategoryt"
      width="70%"
      @ok="addCategory"
    >
      <div class="top">
        <a-input
          style="width: 200px; margin: 10px"
          v-model="factorName"
          allowClear
          placeholder="请输入物质名称"
          @keyup.enter.native="serch"
        />
        <a-button type="primary" @click="serch"> 查询 </a-button>
      </div>
      <div class="bottom">
        <div class="title">
          <span>项目列表</span>
        </div>
        <div class="center">
          <a-table
            :data-source="projectList"
            bordered
            :loading="loading"
            :pagination="false"
            :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
             :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          >
            <a-table-column key="index" title="序号" ellipsis="true" data-index="index" width="100px">
              <template scope="text, record, index">
                {{index + 1 }}
              </template>
            </a-table-column>
            <a-table-column key="pollutantName" title="检测类别" ellipsis="true" data-index="pollutantName" />
            <a-table-column key="item" title="检测项目" ellipsis="true" data-index="item" />
            <a-table-column key="price" title="单价(元)" ellipsis="true" data-index="price" />
            <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
            <a-table-column key="limitRange" title="限值范围" ellipsis="true" data-index="limitRange" />
          </a-table>
        </div>
        <!-- <div class="bottom">
          <a-pagination
            show-size-changer
            show-quick-jumper
            v-model="pagination.current"
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
            @showSizeChange="onShowSizeChange"
            :pageSizeOptions="['10', '20', '30', '40', '50']"
            @change="onShowSizeChange"
          />
        </div> -->
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getOtherTestItemInfoListForWeb,commitOtherTestItem } from '@/api/Industry'
export default {
  data() {
    return {
      factorName: '',
      data: {},
      scroll_y: 700,
      selectedRowKeys: [],
      industryList: [],
      projectList: [],
      addCategoryVisible: false,
      // pagination: {
      //   //分页数据
      //   pageSizeOptions: ['10', '20', '30', '40', '50'],
      //   current: 1,
      //   pageSize: 10,
      //   totalCount: 0,
      // },
    }
  },
  methods: {
    init(data) {
      this.data = data
      console.log(data, 'data===================')
      this.getList(this.data)
    },
  
    getList(data) {
       Object.assign(data,{
         factorName: this.factorName
        // pageNum: this.pagination.current,
        // pageSize: this.pagination.pageSize
      })
      console.log(data, 'data================')
       getOtherTestItemInfoListForWeb(data).then(res=> {
         var array = []
        if(res.code == 200) {
          if(res.data.list) {
             for(var i = 0; i< res.data.list.length; i++) {
            if(res.data.list[i].checked == 1) {
              array.push(i)
            }
            
          }
          this.selectedRowKeys = array

          }
         
          this.projectList = res.data.list
          // this.pagination.totalCount = res.data.totalCount
           this.addCategoryVisible = true

        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //选择其他检测类别
    onSelectChange(selectedRowKeys, val) {
      console.log(selectedRowKeys, val,this.selectedRowKeys, 'selectedRowKeys, val,this.selectedRowKeys')
      //  this.selectedRowKeys = selectedRowKeys
      this.selectedRowKeys= selectedRowKeys
      this.industryList = val
    },
    closeAddCategoryt() {
      this.addCategoryVisible = false
    },
     //分页
    // onShowSizeChange(current, pageSize) {
    //   this.pagination.current = current
    //   this.pagination.pageSize = pageSize
    //   //改变完 重新渲染数据
    //     this.getList(this.data)
    // },
    addCategory() {
    //  var obj = this.industryList
    //  var array = []
    //   for (let i in obj){
    //     console.log(obj[i])
    //     obj[i].forEach(item => {
    //       array.push(item)
    //     })
    //   }
      //提交弹窗内容
      
      commitOtherTestItem({
        sheetId: this.data.sheetId,
        subId: this.data.subId,
        quoteTestItemDetailsVOList:  this.industryList
      }).then(res => {
        if(res.code == 200) {
          // 刷新列表
          this.$emit('refreshList')
          //关闭弹窗
          this.addCategoryVisible = false
          // 清除数据
          this.selectedRowKeys =  []
          this.industryList =  []
        } else {
          this.$message.error(res.msg)

        }

      })
    },
    // 查询
    serch() {
       this.getList(this.data)

    }
  },
}
</script>

<style scoped>
.container .top {
  margin-top: 10px;
  padding: 10px;
}
</style>